export const MIME_TYPE_IMAGE_JPEG = 'image/jpeg';
export const MIME_TYPE_IMAGE_WEBP = 'image/webp';
export const MIME_TYPE_IMAGE_HEIC = 'image/heic';
export const MIME_TYPE_VIDEO_MP4 = 'video/mp4';

export const isVideo = (mimeType?: string) => {
  return !!mimeType && mimeType.startsWith('video/');
};

export const VALID_IMAGE_TYPES = ['image/gif', MIME_TYPE_IMAGE_JPEG, 'image/png', MIME_TYPE_IMAGE_WEBP, MIME_TYPE_IMAGE_HEIC];
